import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { defaultValueWarnings } from '@/interfaces/components/projectNew/DefaultValueWarnings';

/* === Props & Emits === */
interface Props {
    warnings: defaultValueWarnings[];
    isVisible?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultValueWarnings',
  props: {
    warnings: null,
    isVisible: { type: Boolean, default: false }
  },
  emits: ["closeModal"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'closeModal'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { warnings: defaultValueWarnings[], isVisible: boolean };





/* === Warning Display === */
const hasWarnings = computed(() => {
    if (!props.warnings) {
        return false;
    }

    return props.warnings.some((warningItem: defaultValueWarnings) => !!warningItem?.warnings.length);
});

function handleOk() {
    emit('closeModal');
}

return { __sfc: true,props, emit, hasWarnings, handleOk }
}

})